export enum ProductType {
    TravelPlus = "TP",
    LifestyleProtect = "LP",
    BillProtection = "BP"
  }
  
  export const PRODUCT_TYPE_LABEL_MAP = {
    [ProductType.TravelPlus]: "Travel+",
    [ProductType.LifestyleProtect]: "Lifestyle Protect",
    [ProductType.BillProtection]: "Bill Protection"
  };
  
  export function getProductTypeLabel(productType: string): string {
    return PRODUCT_TYPE_LABEL_MAP[productType] || "";
  }
  
  export function getProductTypeList(): string[] {
    return Object.keys(PRODUCT_TYPE_LABEL_MAP);
  }
  